export const rp = (v) => (v == null || v === "" ? "-" : "Rp" + Math.round(Number(v)).toLocaleString("id-ID"));
export const pct = (v) => (v == null ? "-" : `${Number(v).toLocaleString("id-ID", { maximumFractionDigits: 2 })}%`);

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-";

export const ddmmyyyyToIso = (s) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec((s || "").trim());
  if (!m) return null;
  const iso = `${m[3]}-${m[2]}-${m[1]}`;
  const d = new Date(iso);
  return isNaN(d) || d.toISOString().slice(0, 10) !== iso ? null : iso;
};

export const STATUS = {
  baru: { label: "Baru", cls: "bg-[#5720B8]/10 text-[#5720B8]" },
  follow_up: { label: "Follow-up", cls: "bg-[#F28A19]/12 text-[#B5620A]" },
  proses: { label: "Dalam Proses", cls: "bg-[#17223B]/8 text-[#17223B]" },
  berhasil: { label: "Berhasil", cls: "bg-[#078D67]/12 text-[#078D67]" },
  gagal: { label: "Gagal", cls: "bg-red-50 text-red-700" },
};

export const ROLE_LABEL = { super_admin: "Super Admin", admin_ops: "Admin Operasional", marketing: "Marketing" };
export const isAdmin = (u) => u && (u.role === "super_admin" || u.role === "admin_ops");

export const COPYRIGHT_1 = "© by Teguh Pranada-Layanan Pensiunan Pematangsiantar";
export const COPYRIGHT_2 =
  "Prompt by Koperasi Asia Madani Sejahtera, Build Aplication by Teguh Pranada-Layanan Pensiunan Pematangsiantar, Sumatera Utara.";
